import { render, staticRenderFns } from "./ChartSelectorItem.vue?vue&type=template&id=f10156b2&scoped=true&"
import script from "./ChartSelectorItem.vue?vue&type=script&lang=js&"
export * from "./ChartSelectorItem.vue?vue&type=script&lang=js&"
import style0 from "./ChartSelectorItem.vue?vue&type=style&index=0&id=f10156b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10156b2",
  null
  
)

export default component.exports